
  <tcc-mono-dialog-layout
    [title]="'RVO Resultaten'"
    [displayBottomButtons]="false"
  >
    <ion-list>
      <ion-item *ngFor="let item of rvoResults">
        <ion-label class="ion-text-wrap">
          <h3>{{ item.country_code + item.earmark }}</h3>
          <p *ngIf="item.errormessage">
            <ion-text color="danger">
              {{ item.errormessage }}
            </ion-text>
          </p>
        </ion-label>
        <ion-text slot="end" [color]="item.success ? 'success' : 'danger'">
          <fa-icon
            [icon]="['fal', item.success ? 'check' : 'xmark']"
            size="lg"
          ></fa-icon>
        </ion-text>
      </ion-item>
      <ion-item *ngIf="!rvoResults || rvoResults.length === 0">
        <ion-label class="ion-text-wrap">
          <p>
           Geen resultaat
          </p>
        </ion-label>
      </ion-item>
    </ion-list>
  </tcc-mono-dialog-layout>

